//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import { cloneDeep, isEmpty, isUndefined, map, isEqual, isNull } from 'lodash'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
//////COMPONENTS//////
import { ScheduledPricesManagerNested, ScheduledPricesManagerStatus, ScheduledPricesManagerTransmissionStatus } from './Components'
import { campaignPriceActionCreators, scheduledPricesManagerActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import Button from '../../components/Ui/Buttons'
import Theme from '../../theme/theme'
import Modals from '../../components/Modals'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import Table from '../../components/Table'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import UseDatePicker from '../../hooks/UseDatePicker'
import { TextModal, DatePickerFilterLabel } from '../../theme/GlobalCss'
import PriceCampaignUpdateHandler from './PriceCampaignUpdateHandler'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import TooltipHelp from '../../components/TooltipHelp'
import urlExport from '../../constants/UrlExport'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import Calendar from '../../assets/icones/global/calendar.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const DatePickerEffectIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	justify-content: space-between;
	width: 100%;
`
//////STYLED//////

const SalesHistoryManager = () => {
	const {
		user,
		translations,
		scheduledPricesManager,
		scheduledPricesFilters,
		campaign,
		userKioskPerimeter,
		successUpdateCampaignPrice,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			scheduledPricesManager: state.scheduledPricesManager,
			scheduledPricesFilters: state.scheduledPricesManager.header,
			campaign: state.campaignPrice.campaign,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			successUpdateCampaignPrice: state.campaignPrice.update,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const actionsScheduledPricesManager = bindActionCreators(scheduledPricesManagerActionCreators, useDispatch())
	const priceCampaignActions = bindActionCreators(campaignPriceActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'createdDate', nameDir: 'asc' })

	const [ttc, setTtc] = useState(filters.withTTC)

	// Modals
	const [row, setRow] = useState({})
	const [showModalTransmission, setShowModalTransmission] = useState(false)
	const [showModalEditCampaign, setShowModalEditCampaign] = useState(false)
	const [showModalCancelCampaign, setShowModalCancelCampaign] = useState(false)
	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const [dateEffectShowModal, dateEffectOpenDateModalHandler, dateEffectRenderModal, dateEffectStateDate] = UseDatePicker({
		defaultDateStart: moment().startOf('day').subtract(7, 'days').toDate(),
		defaultDateEnd: moment().hours(23).minutes(59).add(7, 'days').toDate(),
	})

	const [configTransmission, setConfigTransmission] = useState({
		name: '',
		fixedColumnSelection: true,
	})

	// Columns
	const [columns, setColumns] = useState([])

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handlePagingSalesHistory = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'createdDate',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'asc',
			},
		}
		setPaging(pg)
		actionsScheduledPricesManager.getScheduledPrices(handleFilterSend(), pg)
	}

	const handleCloseModal = () => {
		setShowModalTransmission(false)
	}

	const handleModalTramission = (dataRow) => {
		setRow({ ...dataRow })
		if (!showModalTransmission && !isNull(dataRow?.id)) {
			let cfg = cloneDeep(configTransmission)
			cfg.name = `${translations['modal__pricesManagement__pricesCampaign_transmition_title']} : ${dataRow.label}`
			cfg.close = true
			cfg.actions = {
				handleCloseModal: handleCloseModal,
			}
			setConfigTransmission(cfg)
			// back call
			actionsScheduledPricesManager.getTransmission(dataRow.id)
			setShowModalTransmission(true)
		} else {
			setShowModalTransmission(false)
		}
	}

	const handleModalEditCampaign = (dataRow) => {
		setRow({ ...dataRow })
		// back call
		if (!showModalEditCampaign && !isNull(dataRow?.id)) {
			priceCampaignActions.getCampaign(dataRow?.id)
			setShowModalEditCampaign(true)
		} else {
			priceCampaignActions.resetCampaignItems()
			setShowModalEditCampaign(false)
		}
	}

	const handleModalCancelCampaign = (dataRow) => {
		setRow({ ...dataRow })
		// back call
		if (!showModalCancelCampaign) {
			setShowModalCancelCampaign(true)
		} else {
			priceCampaignActions.cancelCampaign(dataRow.id)
			setShowModalCancelCampaign(false)
		}
	}

	const handleWithTTC = () => {
		let filtersCP = cloneDeep(filters)
		filtersCP.withTTC = !filtersCP.withTTC

		setFilters(filtersCP)
		const str_filters = handleFilterSend()
		// Even if we set our hook, in HandleFilterSend,
		// TTC value is not actualised,
		// So we reset value here...
		str_filters.withTTC = filtersCP.withTTC
		setTtc(filtersCP.withTTC)
		actionsScheduledPricesManager.getScheduledPrices(str_filters, paging)
	}
	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change

		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'createdDate', nameDir: 'asc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsScheduledPricesManager.getScheduledPrices(handleFilterSend(), pg)
	}

	const handleFilterSend = (withNested = false) => {
		return {
			...filters,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
			datesRange: {
				dateStart: dateEffectStateDate.date.startDate,
				dateEnd: dateEffectStateDate.date.endDate,
			},
			withNested: withNested,
		}
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'priceUpdate_status',
				dataHook: 'priceCampaignStatus.translationKey',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_status'],
				sortable: true,
				isAuthorize: true,
				component: ScheduledPricesManagerStatus,
				sortableId: 'campaignStatus.description',
			},
			{
				columnReferential: 'priceUpdate_kioskTransmissionStatus',
				dataHook: 'transmitionStatus.translationKey',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_transmitionStatus'],
				sortable: true,
				isAuthorize: true,
				component: ScheduledPricesManagerTransmissionStatus,
				sortableId: 'transmitionStatus.description',
			},
			{
				columnReferential: 'priceUpdate_creationType',
				dataHook: 'priceCampaignType.translationKey',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_creationMode'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'campaignType.label',
			},
			{
				columnReferential: 'priceUpdate_name',
				dataHook: 'label',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_name'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'label',
			},
			{
				columnReferential: 'priceUpdate_createAt',
				dataHook: 'createdDate',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_createdAt'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.createdDate) ? moment(props.row.createdDate).format('DD/MM/YYYY HH:mm') : '-'),
				sortableId: 'createdDate',
			},
			{
				columnReferential: 'priceUpdate_createBy',
				dataHook: 'createdBy',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_createdBy'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'userCreated.lastName',
			},
			{
				columnReferential: 'priceUpdate_effectiveDate',
				dataHook: 'dateStart',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_dateStart'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.dateStart) ? moment(props.row.dateStart).format('DD/MM/YYYY HH:mm') : '-'),
				sortableId: 'dateStart',
			},
			{
				columnReferential: 'priceUpdate_lastTransmission',
				dataHook: 'dateLastTransmition',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_lastTransmition'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'lastPriceUpdateKioskLineTransmitted.dateTransmitted',
				component: (props) =>
					!isNull(props.row.dateLastTransmission) ? moment(props.row.dateLastTransmission).format('DD/MM/YYYY HH:mm') : '-',
			},
			{
				columnReferential: 'priceUpdate_distributor',
				dataHook: 'labelDistributor',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_distributor'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'distributor.company.labelToDisplay',
			},
			{
				columnReferential: 'priceUpdate_impactedKiosk',
				dataHook: 'kioskQuantity',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_kioskNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'priceUpdateKioskLines.size',
			},
			{
				columnReferential: 'priceUpdate_impactedItem',
				dataHook: 'itemQuantity',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_itemNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'priceUpdateCampaignLines.size',
			},
			{
				columnReferential: 'priceUpdate_priceUpdate',
				dataHook: 'toApplyNow',
				headerName: translations['page__pricesManagement__pricesCampaign_tableHeader_toApplyNow'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (translations[props.row.toApplyNow] ? translations[props.row.toApplyNow] : '-'),
				sortableId: 'toApplyNow',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: false,
				rest: {
					tooltipPart: 'scheduledPriceManager',
					paperActionsList: [
						{
							//iconDef: checkTransmissionIcon,
							name: translations['tooltip__admin__priceManagement__priceCampaign__transmissionDetail'],
							clickAction: (row) => {
								handleModalTramission(row)
							},
							isVisible: (row) => true,
							translationKey: 'tooltip__admin__priceManagement__priceCampaign__transmissionDetail',
						},
						{
							//iconDef: editPriceCampaignIcon,
							name: translations['tooltip__admin__priceManagement__priceCampaign__updatePrice'],
							clickAction: (row) => {
								handleModalEditCampaign(row)
							},
							isVisible: (row) => row.priceCampaignStatus.subFlow !== '100' && row.priceCampaignStatus.subFlow !== '999',
							translationKey: 'tooltip__admin__priceManagement__priceCampaign__updatePrice',
						},
						{
							//icon: cancelPriceCampaignIcon,
							name: translations['tooltip__admin__priceManagement__priceCampaign__cancelCampaign'],
							clickAction: (row) => {
								handleModalCancelCampaign(row)
							},
							isVisible: (row) => row.priceCampaignStatus.subFlow === '001',
							translationKey: 'tooltip__admin__priceManagement__priceCampaign__cancelCampaign',
						},
					],
				},
				checkRight: userPrivileges.action[2],
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 4,
		labelPageTable: 'priceUpdate',
	}

	const columnsTransmission = [
		{
			dataHook: 'kioskName',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_kioskName'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'transmitionStatus.translationKey',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_transmitionStatus'],
			sortable: true,
			isAuthorize: true,
			component: ScheduledPricesManagerTransmissionStatus,
		},
		{
			dataHook: 'transmissionDate',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_date'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.transmissionDate) ? moment(props.row.transmissionDate).format('DD/MM/YYYY HH:mm') : '-'),
		},
		{
			dataHook: 'codeKiosk',
			headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_kioskCode'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'customerCodeKiosk',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_customerCodeKiosk'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'postalCode',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_postalCode'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'city',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_city'],
			sortable: true,
			isAuthorize: true,
		},
	]

	//Config
	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			toggleLists: [
				() => (
					<ToggleFilters
						defaultChecked
						onChangeHandler={handleWithTTC}
						name="withTTC"
						labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
						labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
					/>
				),
			],
			dateLists: [
				() => (
					<Fragment>
						<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
							{translations['page__pricesManagement__pricesCampaign_filters_date']} :
						</label>
						<DatePickerEffectIcon onClick={dateEffectOpenDateModalHandler} />
						<DatePickerFilterLabel>
							<span>
								{translations['page__global__admin__header_datePicker_from']}{' '}
								{isEqual(dateEffectStateDate.date.startDate, {})
									? moment(new Date()).subtract(1, 'months').format('DD/MM/YYYY HH:mm')
									: moment(dateEffectStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
							</span>
							<span>
								{translations['page__global__admin__header_datePicker_to']}{' '}
								{isEqual(dateEffectStateDate.date.endDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateEffectStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
							</span>
						</DatePickerFilterLabel>
					</Fragment>
				),
			],
		},
		paging: {
			fnSendTo: (paging) => handlePagingSalesHistory(paging),
		},
	})
	const [configTable, setConfigTable] = useState({
		nestedValues: {
			value: true,
			nestedData: 'priceCampaignLines',
			nestedComponent: ScheduledPricesManagerNested,
			nestedPointer: 'id', // To retrieve index of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			nestedPointerValuePath: 'props.row.id', // To retrieve value of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			toggleAllNestedPointer: 'toggleNested', // Are we seeing nested lines or not
			nestedUnitCall: (dataRow) => actionsScheduledPricesManager.getPriceCampaignNestedLines(dataRow.id, ttc),
			nestedMassCall: () => actionsScheduledPricesManager.getScheduledPrices(handleFilterSend(true), paging),
		},
	})

	/* 	useEffect(() => {
			let cfg = cloneDeep(configTable)
			cfg.nestedValues.value = true
			cfg.nestedValues.nestedData = 'priceCampaignLines'
			cfg.nestedValues.nestedComponent = ScheduledPricesManagerNested
			cfg.nestedValues.nestedPointer = 'id'
			cfg.nestedValues.nestedPointerValuePath = 'props.row.id'
			//cfg.nestedValues.toggleAllNestedPointer = 'toggleNested' 
			cfg.nestedValues.nestedUnitCall = (dataRow) => actionsScheduledPricesManager.getPriceCampaignNestedLines(dataRow.id, ttc)
	
			setConfigTable(cfg)
		}, [translations, filters, prevFilter]) */
	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		if (dateEffectStateDate.showModal) {
			actionsScheduledPricesManager.getScheduledPrices(handleFilterSend(), paging)
		}
	}, [dateEffectShowModal])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(scheduledPricesManager) && !isUndefined(scheduledPricesManager)) {
			cfg.paging = {
				totalElements: scheduledPricesManager.paging.totalElements,
				totalPages: scheduledPricesManager.paging.totalPages,
				fnSendTo: (paging) => handlePagingSalesHistory(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [scheduledPricesManager])

	useEffect(() => {
		if (isEmpty(translations)) return
		const filters = cloneDeep(scheduledPricesFilters)

		filters.withFilters = true

		setFilters(filters)
		setPrevFilter(filters)
	}, [scheduledPricesFilters, translations])

	useEffect(() => {
		if (isEmpty(filters.filtersSelection)) return

		let cfg = cloneDeep(configTableTitle)
		cfg.name = translations['page__pricesManagement__pricesCampaign_title']

		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['page__pricesManagement__pricesCampaign_filters_date']} :
					</label>
					<DatePickerEffectIcon onClick={dateEffectOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{isEqual(dateEffectStateDate.date.startDate, {})
								? moment(new Date()).subtract(1, 'months').format('DD/MM/YYYY HH:mm')
								: moment(dateEffectStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{isEqual(dateEffectStateDate.date.endDate, {})
								? moment(new Date()).format('DD/MM/YYYY HH:mm')
								: moment(dateEffectStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesCampaign_dropDown_transmition']}
					data={filters.filtersSelection.campaignTransmission.filterElements}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'campaignTransmission'}
					toTranslate={true}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesCampaign_dropDown_creationMode']}
					data={filters.filtersSelection.campaignType.filterElements}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'campaignType'}
					toTranslate={true}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesCampaign_dropDown_priceUpdate']}
					data={filters.filtersSelection.toApplyNow.filterElements}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'toApplyNow'}
					toTranslate={true}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesCampaign_dropDown_status']}
					data={filters.filtersSelection.campaignStatus.filterElements}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'campaignStatus'}
					toTranslate={true}
				/>
			),
		]
		cfg.actions.toggleLists = [
			() => (
				<TooltipHelp content={'tooltipHelp__admin__modal__body__table__filter__vatSwitch'} childrenPos={2}>
					<ToggleFilters
						checked={filters.withTTC}
						onChangeHandler={handleWithTTC}
						size={'large'}
						name="withTTC"
						labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
						labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
					/>
				</TooltipHelp>
			),
		]

		cfg.paging = {
			totalElements: scheduledPricesManager.paging.totalElements,
			totalPages: scheduledPricesManager.paging.totalPages,
			fnSendTo: (paging) => handlePagingSalesHistory(paging),
		}

		setConfigTableTitle(cfg)

		let cfg2 = cloneDeep(configTable)

		cfg2.nestedValues.nestedMassCall = () => actionsScheduledPricesManager.getScheduledPrices(handleFilterSend(true), paging, true)
		cfg2.nestedValues.nestedUnitCall = (dataRow) => actionsScheduledPricesManager.getPriceCampaignNestedLines(dataRow.id, filters.withTTC)

		setConfigTable(cfg2)
	}, [translations, filters, prevFilter, dateEffectStateDate])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[3],
			url: urlExport[10],
			bd: {
				filtersSelection: filters.filtersSelection,
				withFilters: true,
				withTTC: filters.withTTC,
				withNested: true,
				datesRange: { dateEnd: dateEffectStateDate.date.endDate, dateStart: dateEffectStateDate.date.startDate },
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}
		cfgCp.nestedValues.nestedMassCall = () => actionsScheduledPricesManager.getScheduledPrices(handleFilterSend(true), paging, true)
		cfgCp.nestedValues.nestedUnitCall = (dataRow) => actionsScheduledPricesManager.getPriceCampaignNestedLines(dataRow.id, filters.withTTC)

		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (isEmpty(filters)) {
			const filtersCp = {
				withFilters: false,
				withNested: false,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				withTTC: false,
				datesRange: {
					// Dummy dates
					dateStart: moment().startOf('day').subtract(7, 'days').toDate(),
					dateEnd: moment().hours(23).minutes(59).add(7, 'days').toDate(),
				},
			}
			actionsScheduledPricesManager.getScheduledPrices(filtersCp)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [user, translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsScheduledPricesManager.getScheduledPrices(handleFilterSend(), paging)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	// After updating promo
	useEffect(() => {
		if (successUpdateCampaignPrice) {
			actionsScheduledPricesManager.getScheduledPrices(handleFilterSend(), paging)
		}
	}, [successUpdateCampaignPrice])

	useEffect(() => {
		return function cleanUp() {
			actionsScheduledPricesManager.resetScheduledPricesManager()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={scheduledPricesManager.items}
				inputConfig={configTable}
				isLoading={scheduledPricesManager.isLoading}
				currentPaging={paging}
				tableReferential={tableReferential}
				actionSort={actionsScheduledPricesManager.getScheduledPrices}
			/>
		)
	}, [scheduledPricesManager, columns, configTable, translations, paging])

	return (
		<Fragment>
			{dateEffectRenderModal()}
			{!isEqual(campaign, {}) && (
				<PriceCampaignUpdateHandler
					closeModalHandler={handleModalEditCampaign}
					showModal={showModalEditCampaign}
					data={campaign}
					widthTaxes={filters.withTTC}
					errors={scheduledPricesManager.error?.data || []}
					updateMode
				/>
			)}
			<Modals closeModalHandler={handleModalTramission} showModal={showModalTransmission} minWidth={1200}>
				{/* <PageWrapperActions>
					<PageWrapperActionPrevPage onClick={() => handleCloseModal()} />
				</PageWrapperActions> */}
				{translations && showModalTransmission && (
					<>
						<TableTitle inputConfig={configTransmission} isSortColumns={false} />
						<Table
							inputColumns={columnsTransmission}
							inputData={scheduledPricesManager.transmission}
							inputConfig={configTransmission}
							currentPaging={paging}
							actionSort={actionsScheduledPricesManager.getScheduledPrices}
						/>
					</>
				)}
			</Modals>
			<Modals
				closeModalHandler={() => setShowModalCancelCampaign(false)}
				showModal={showModalCancelCampaign}
				title={translations['modal__pricesManagement__pricesCampaign_cancelation_title']}
				level="error"
				icon={true}
			>
				<TextModal>
					<p>{translations['modal__pricesManagement__pricesCampaign_cancelation_message']}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={() => setShowModalCancelCampaign(false)}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>

					<Button
						actionHandler={() => {
							handleModalCancelCampaign(row)
						}}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

SalesHistoryManager.propTypes = {}

SalesHistoryManager.defaultPropTypes = {}

export default SalesHistoryManager
